// fonts
export const fontSizeBase = 1.6;
export const modularScale = 1.25;
const fontFamilyHeadings = "Fredoka, 'Trebuchet MS', 'Segoe UI', system-ui, sans-serif";

// breakpoints
export const breakpoints = {
  xsm: "360px",
  sm: "480px",
  smPlus: "699px",
  md: "700px",
  mdPlus: "1023px",
  lg: "1024px",
  lgPlus: "1279px",
  xl: "1280px",
  xlPlus: "1479px",
  xxl: "1480px",
};

export const spacers = {
  n: 0,
  xs: "1rem",
  sm: "2rem",
  md: "3rem",
  lg: "4rem",
  xl: "5rem",
};

const colors = {
  // Custom DGEO colors
  dgeoViolet: '#6B4C9A',
  dgeoVioletLight: '#B19CD9',
  dgeoVioletPale: '#D4C5E8',
  dgeoBlue: '#5B8DB8',
  dgeoTeal: '#5FA9A0',
  dgeoGreen: '#7CB798',
  dark: '#2D3436',
  light: '#F5F5F5',
  white: '#FFFFFF',
  beige: '#F8F6F2',

  primary: "#5F63BB",
  primaryDark: "#413C73",
  primaryLight: "#5357B3",
  primary100: "#F1F2FF",
  primary200: "#DFE0ED",
  primary700: "#5C5787",
  secondary: "#16D8C5",
  secondaryDark: "#14B9A9",
  secondaryLight: "#D0F7F4",
  secondary300: "#D3F0EE",
  tertiary: "#FF6260",
  tertiaryLight: "#FFE8E7",
  border: "#F3F3F3",
  inputBorder: "#E1E1E1",
  error: "red",
  error200: "#FFEAEA",
  error500: "#FF6260",
  error700: "#E54846",
  success: "green",
  success200: "#E9F9F5",
  success500: "#16D8AB",
  success700: "#00A07A",
  retry: "#FFB560",
  gray100: "#F6F7FC",
  gray200: "#FAFAFA",
  gray300: "#ECECEC",
  gray500: "#888885",
  gray700: "#636363",
  text: "#313030",
  placeholder: "#BDBDBD",
  selectLabel: "#818181",
  black: "#3B3B3B",
  arts: "#F47A44",
  artsLight: "rgba(221, 153, 0, .13)",
  body: "#0083CA",
  bodyLight: "rgba(0, 131, 202, .13)",
  general: "#6D4099",
  generalLight: "rgba(221, 153, 0, .13",
  languages: "#DD9900",
  languagesLight: "rgba(221, 153, 0, .13)",
  mathematics: "#DB3332",
  mathematicsLight: "rgba(219, 51, 50, .13)",
  others: "#939393",
  othersLight: "rgba(147, 147, 147, .13)",
  social: "#007046",
  socialLight: "rgba(0, 112, 70, .13)",
  transversal: "#926E43",
  transversalLight: "rgba(146, 110, 67, .13)",
};

export const theme = {
  breakpoints: [
    breakpoints.sm,
    breakpoints.md,
    breakpoints.lg,
    breakpoints.xl,
    breakpoints.xxl,
  ],
  fonts: {
    base: "'Work Sans', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    heading: fontFamilyHeadings,
    mono: '"Courier New", Courier, monospace',
  },
  heading: {
    fontFamily: fontFamilyHeadings,
  },
  fontSizes: ["1.4rem", "1.6rem"],
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  lineHeightBase: 1.5,
  colors: {
    ...colors,
  },
  space: [
    spacers.n,
    spacers.xs,
    spacers.sm,
    spacers.md,
    spacers.lg,
    spacers.xl,
  ],
};
